<template>
    <v-container class="ma-0 pa-0">
        <v-row class="ma-0 pa-0">
            <v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Macchinario TEMA</p>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
					<template v-slot:activator="{ on }">
                        <v-btn @click="initialize()" :loading="loading" v-on="on" icon>
                            <v-icon>refresh</v-icon>
                        </v-btn>
					</template>
                    <span>Refresh</span>
                </v-tooltip>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text class="pa-0" style="word-break: break-word">
                    <v-container class="px-0 py-2 pb-0 pt-2" fluid>

                        <v-row class="ma-0 mt-8" style="max-height: 350px;">
                            <v-card-text class="pa-0">
                                <div style="display: flex; margin: auto; width: 100%; margin: auto; flex: 1 1 auto;">
                                    <div class="flex-column" style="margin: auto; margin-right: 0;">
                                        <span class="display- margin-auto red--text text--accent3  font-weight-thin"></span>
                                        <span class="margin-auto text-uppercase font-weight-light"></span>
                                    </div>                        
                                    <div class="flex-column" style="margin: auto;">
                                        <span class="display-1 margin-auto primary--text font-weight-thin">{{ model.data | datetime }}</span>
                                        <span class="margin-auto text-uppercase font-weight-light pb-4">Data</span>
                                    </div>          
                                    <div class="flex-column" style="margin: auto; margin-left: 0;">
                                        <span class="display- margin-auto red--text text--accent3  font-weight-thin"></span>
                                        <span class="margin-auto text-uppercase font-weight-light"></span>
                                    </div>                  
                                </div>
                            </v-card-text>       
                        </v-row>

                        <v-row class="ma-0" style="max-height: 350px;">
                            <v-card-text class="pa-0">
                                <div style="display: flex; margin: auto; width: 100%; margin: auto; flex: 1 1 auto;">
                                    <div class="flex-column" style="margin: auto; margin-right: 0;">
                                        <span class="display-1 margin-auto red--text text--accent3  font-weight-thin">{{ model.ordine }}</span>
                                        <span class="margin-auto text-uppercase font-weight-light">Ordine N</span>
                                    </div>
                                    <div class="flex-column" style="margin: auto;">
                                        <span class="display-3 margin-auto light-green--text text--accent-4 font-weight-thin">{{ model.qta_da_produrre }}</span>
                                        <span class="margin-auto text-uppercase font-weight-light pb-4">Quantità da produrre</span>
                                    </div>
                                    <div class="flex-column" style="margin: auto; margin-left: 0;">
                                        <span class="display-1 margin-auto light-blue--text accent-3 font-weight-thin">{{ model.qta_prodotta }}</span>
                                        <span class="margin-auto text-uppercase font-weight-light">Quantità Prodotta</span>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-row>

                        <v-row class="ma-0 mb-8" style="max-height: 350px;">
                            <v-card-text class="pa-0">
                                <div style="display: flex; margin: auto; width: 100%; margin: auto; flex: 1 1 auto;">
                                    <div class="flex-column" style="margin: auto;">
                                        <span class="display-3 margin-auto light-green--text text--accent-4 font-weight-thin">{{ model.stato_macchina }}</span>
                                        <span class="margin-auto text-uppercase font-weight-light pb-4">Stato macchina</span>
                                    </div>
                                    <div class="flex-column" style="margin: auto; margin-left: 0;">
                                        <span class="display-1 margin-auto light-blue--text accent-3 font-weight-thin">{{ model.codice_allarme ? model.codice_allarme : 'Nessuno' }}</span>
                                        <span class="margin-auto text-uppercase font-weight-light">Codice allarme</span>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-row>

                    </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click.native.stop="resetMachinery()">Reset</v-btn>
                </v-card-actions>        
            </v-card>
        </v-row>
        
        <v-row class="ma-0 pa-0">
            <v-card class="flex pa-0 mt-4 round-card background-2">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Statistiche Macchinario TEMA</p>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>

                    <gmh-date-picker
                        v-model="from"
                        label="Dal"
                        field-class="pr-4"
                        hide-details
                        :clearable="false"
                    ></gmh-date-picker>
                    <gmh-date-picker
                        v-model="to"
                        label="Al"
                        field-class="pr-4"
                        hide-details
                        :clearable="false"
                    ></gmh-date-picker>

                </v-card-title>
                <v-divider></v-divider>

                <v-card-text class="pa-0" style="word-break: break-word">
                    <v-container class="px-0 py-2 pb-0 pt-2" fluid>

                        <v-row class="ma-0 mt-8" style="max-height: 350px;">
                            <v-card-text class="pa-0">
                                <div style="display: flex; margin: auto; width: 100%; margin: auto; flex: 1 1 auto;">
                                    <div class="d-flex" style="margin: auto;">
                                        <div class="display-1 margin-auto font-weight-thin">Tempo di collegamento: </div>
                                        <div class="display-1 margin-auto text-uppercase font-weight-light">{{ totalDuration | duration }} h</div>
                                    </div>                                     
                                </div>
                            </v-card-text>       
                        </v-row>

                        <v-row class="ma-0 my-8" style="max-height: 350px;">
                            <v-card-text class="pa-0" v-if="machinestatuses[0]">
                                <div style="display: flex; margin: auto; width: 100%; margin: auto; flex: 1 1 auto;">
                                    <div class="flex-column" style="margin: auto; margin-right: 0;">
                                        <span class="display-1 margin-auto red--text text--accent3  font-weight-thin">{{ machinestatuses[0].duration | duration }} h</span>
                                        <span class="display-2 margin-auto red--text text--accent3  font-weight-thin">{{ ((machinestatuses[0].duration / totalDuration ) *100).toFixed(0) }} %</span>
                                        <span class="margin-auto text-uppercase font-weight-light">Ferma Accesa (Porte Chiuse)</span>
                                    </div>
                                    <div class="flex-column" style="margin: auto;">
                                        <span class="display-1 margin-auto light-green--text text--accent-4 font-weight-thin">{{ machinestatuses[1].duration | duration }} h</span>
                                        <span class="display-2 margin-auto light-green--text text--accent-4 font-weight-thin">{{ ((machinestatuses[1].duration / totalDuration ) *100).toFixed(0) }} %</span>
                                        <span class="margin-auto text-uppercase font-weight-light pb-4">Accesa Ferma (porte Aperte)</span>
                                    </div>
                                    <div class="flex-column" style="margin: auto; margin-left: 0;">
                                        <span class="display-1 margin-auto light-blue--text accent-3 font-weight-thin">{{ machinestatuses[2].duration | duration }} h</span>
                                        <span class="display-2 margin-auto light-blue--text accent-3 font-weight-thin">{{ ((machinestatuses[2].duration / totalDuration ) *100).toFixed(0) }} %</span>
                                        <span class="margin-auto text-uppercase font-weight-light">Start</span>
                                    </div>
                                    <div class="flex-column" style="margin: auto; margin-left: 0;">
                                        <span class="display-1 margin-auto orange--text accent-3 font-weight-thin">{{ machinestatuses[3].duration | duration }} h</span>
                                        <span class="display-2 margin-auto orange--text accent-3 font-weight-thin">{{ ((machinestatuses[3].duration / totalDuration ) *100).toFixed(0) }} %</span>
                                        <span class="margin-auto text-uppercase font-weight-light">Allarme</span>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-row>

                    </v-container>
                </v-card-text>

            </v-card>
        </v-row>
    </v-container>
</template>

<script>

export default {

    name: 'machinery',
    data() {
        return {
            model: {},
            machinestatuses: [],
            loading: false,
            from: moment().startOf('month').format('YYYY-MM-DD'),
            to: moment().endOf('month').format('YYYY-MM-DD'),
            timer: null
        }
    },

    computed: {
        totalDuration() {
            return this.machinestatuses.reduce((acc, status) => acc + parseInt(status.duration), 0)
        }
    },

    watch: {

        from: {
            handler(newValue, oldValue) {
                this.getAnalytics()
            }
        },
        to: {
            handler(newValue, oldValue) {
                this.getAnalytics()
            }
        },
    },

	methods: {
		resetMachinery() {
            this.axios.get('machineprocesses-reset').then(response => {
                // get body data
                let data = response.data
                let snackmessage = ''
                let snackcolor = ''
                if(data.status == 'success'){
                    snackmessage = 'Reset effettuato con successo'
                    snackcolor = 'success'
                } else{
                    snackmessage = data.message
                    snackcolor = 'warning'
                }
                this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})

                this.loading = false
                this.$emit('close')
                this.initialize()
            }, response => {
                this.loading = false
            })
		},

        getAnalytics() {
            this.loading = true
            let dataObject = {from: this.from, to: this.to}
            this.axios.post('/getMachineryAnalytics', dataObject).then(response => {
                // get body data
                this.machinestatuses = response.data.data
                this.$store.commit('endProgress')
                this.loading = false

            }, response => {
                this.loading = false
            })            
        },

        initialize(analytics = true) {
            this.loading = true
            this.axios.get('/getMachineryInfo').then(response => {
                // get body data
                if(response.data.data && response.data.data.risposta == 200) {
                    this.model = response.data.data
                } else {
                    this.$store.commit('setSnackbar', {timeout: 6000, text: 'Errore', value: true, color: 'error'})
                }
                this.$store.commit('endProgress')
                if(analytics) {
                    this.getAnalytics()
                }
                this.loading = false

            }, response => {
                this.loading = false
            })
        }
	},    

    created() {
        this.initialize()
    },

    mounted() {
        this.timer = setInterval(() => {
            this.initialize(false)
        }, 60000)        
    },

    beforeDestroy() {
        clearInterval(this.timer)
    }    
}
</script>
